import { connect } from "react-redux";
import HotoSiteListing from "./hotoSiteListing";
import { bindActionCreators } from "redux";
import { getGOLiveFilterDropDown } from "services/redux/maintenance/goLiveSite/action";
import { fetchHotoSites } from "services/redux/maintenance/hoto/action";
import HotoReducer from "../../../services/redux/maintenance/hoto/reducer";

const mapStateToProps = (state) => ({
  hotoSiteData: state.HotoReducer.hotoSiteData,
  liveFilterDropDown: state.liveSiteDataReducer.liveFilterDropDown
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchHotoSites,
      getGOLiveFilterDropDown
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(HotoSiteListing);
